import { DateTime } from "luxon";

// Converts a JS Date (e.g. from a date picker) into a plain ISO date string (yyyy-mm-dd) for API query params.
export const toIsoDate = (date: Date | string | null | undefined): string => {
  if (!date) return "";
  return DateTime.fromJSDate(new Date(date)).toISODate() ?? "";
};

export default toIsoDate;
